import OrderNowButton from './OrderNowButton';

export default OrderNowButton;
